import React, { useState } from "react";
import { Button } from "../ui/button";
import { Users, User } from "lucide-react";

export default function PhasePersonType({ data, onNext, loading }) {
  const [personType, setPersonType] = useState(data.person_type || "");

  const handleContinue = () => {
    if (!personType) return;
    onNext({ person_type: personType });
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-white mb-2">Tipo de Persona</h2>
        <p className="text-slate-400 text-sm">Selecciona el tipo de cliente que deseas registrar</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
        <button
          onClick={() => setPersonType("fisica")}
          className={`p-6 rounded-xl border-2 transition-all ${
            personType === "fisica"
              ? "border-teal-600 bg-teal-600/10"
              : "border-slate-700 hover:border-slate-600"
          }`}
        >
          <User size={48} className={`mx-auto mb-3 ${
            personType === "fisica" ? "text-teal-400" : "text-slate-400"
          }`} />
          <h3 className="text-lg font-semibold text-white mb-1">Persona Física</h3>
          <p className="text-sm text-slate-400">Individuo o persona natural</p>
        </button>

        <button
          onClick={() => setPersonType("moral")}
          className={`p-6 rounded-xl border-2 transition-all ${
            personType === "moral"
              ? "border-teal-600 bg-teal-600/10"
              : "border-slate-700 hover:border-slate-600"
          }`}
        >
          <Users size={48} className={`mx-auto mb-3 ${
            personType === "moral" ? "text-teal-400" : "text-slate-400"
          }`} />
          <h3 className="text-lg font-semibold text-white mb-1">Persona Moral</h3>
          <p className="text-sm text-slate-400">Empresa o entidad jurídica</p>
        </button>
      </div>

      <div className="flex justify-end mt-8">
        <Button
          onClick={handleContinue}
          disabled={!personType || loading}
          className="bg-teal-600 hover:bg-teal-500 text-white"
          data-testid="continue-btn"
        >
          Continuar →
        </Button>
      </div>
    </div>
  );
}
